import { Fragment, useEffect, useState } from 'react'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
  Tab,
  TabGroup,
  TabList,
  TabPanel,
  TabPanels,
} from '@headlessui/react'
import { Link, useNavigate } from "react-router-dom";
import methodModel from "../../../methods/methods";
import { LuLogOut, LuUser } from "react-icons/lu";
import { IoSettingsOutline } from "react-icons/io5";
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { MdOutlineShoppingCartCheckout } from 'react-icons/md';
import environment from '../../../environment';
import { useDispatch, useSelector } from 'react-redux';
import { getCheckoutItems } from '../../../redux/thunk/checkoutItem';
import ApiClient from '../../../methods/api/apiClient';

const Html = ({ isOpen, setIsOpen, user, isOpen1, Logout }) => {
  const token = sessionStorage.getItem('token')
  // const [navigation, setNavigation] = useState({
  //   categories: [
  //     {
  //       id: 'women',
  //       name: 'Create',
  //       featured: [
  //         {
  //           name: 'New Arrivals',
  //           href: '#',
  //           imageSrc: '/assets/img/ed/one.png',
  //           imageAlt: 'Models sitting back to back, wearing Basic Tee in black and bone.',
  //         },
  //         {
  //           name: 'Basic Tees',
  //           href: '#',
  //           imageSrc: '/assets/img/ed/two.png',
  //           imageAlt: 'Close up of Basic Tee fall bundle with off-white, ochre, olive, and black tees.',
  //         },
  //       ],
  //       sections: [
  //         {
  //           id: 'clothing',
  //           name: 'Thank you',
  //           items: [
  //             { name: 'Tops', href: '#' },
  //             { name: 'Dresses', href: '#' },
  //             { name: 'Pants', href: '#' },
  //             { name: 'Denim', href: '#' },
  //             { name: 'Sweaters', href: '#' },
  //             { name: 'T-Shirts', href: '#' },
  //           ],
  //         },
  //         {
  //           id: 'accessories',
  //           name: 'Festival',
  //           items: [
  //             { name: 'Watches', href: '#' },
  //             { name: 'Wallets', href: '#' },
  //             { name: 'Bags', href: '#' },
  //             { name: 'Sunglasses', href: '#' },
  //             { name: 'Hats', href: '#' },
  //             { name: 'Belts', href: '#' },
  //           ],
  //         },
  //         {
  //           id: 'brands',
  //           name: 'Cards',
  //           items: [
  //             { name: 'Full Nelson', href: '#' },
  //             { name: 'My Way', href: '#' },
  //             { name: 'Re-Arranged', href: '#' },
  //             { name: 'Counterfeit', href: '#' },
  //             { name: 'Significant Other', href: '#' },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  //   pages: [

  //     // { name: 'Templates', href: '#' },
  //     // { name: 'Examples', href: '#' },
  //     // { name: 'Learn', href: '#' },
  //     // { name: 'Pricing', href: '#' },
  //     { name: 'Blogs', href: '/blogs' },
  //     { name: 'Contact us', href: '/contactus' },
  //   ],
  // })
  const [navigation, setNavigation] = useState({
    categories: [],
    pages: [],
  })
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const checkOutData = useSelector((state) => state.checkoutItem.data)

  useEffect(() => {
    getCards()
    document.documentElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    dispatch(getCheckoutItems())
  }, [])

  const getCards = () => {
    ApiClient.get(`card/listing?status=active`).then(res => {
      if (res.success) {
        setNavigation((prev) => ({
          ...prev,
          categories: prev?.categories?.map((item) => {
            return ({
              ...item,
              sections: ["Thinking of You", "Love", "Emotional Feelings"]?.map((section) => {
                return ({
                  id: section,
                  name: section,
                  items: res?.data?.filter((card) => {
                    if (card?.categoryDetail?.name === section) {
                      return card
                    }
                  })
                })
              }),
              featured: res?.data?.filter((card, index) => {
                if (index < 2) {
                  return card
                }
              })
            })
          })
        }))
      }
    })
  }

  const sections = [
    { title: "My Cards", path: "/mycards", show: token ? true : false },
    { title: "My Transactions", path: "/mytransactions", show: token && user?.role?._id !== environment?.recipientRole ? true : false }
  ]

  return (
    <>
      <div className="bg-[#FFF4F4]">
        {/* Mobile menu */}
        <Dialog open={open} onClose={setOpen} className="relative z-40 lg:hidden">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-black bg-opacity-25 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
          />
          <div className="fixed inset-0 z-40 flex">
            <DialogPanel
              transition
              className="relative flex w-full max-w-xs transform flex-col overflow-y-auto bg-white pb-12 shadow-xl transition duration-300 ease-in-out data-[closed]:-translate-x-full"
            >
              <div className="flex px-4 pb-2 pt-5">
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="relative -m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400"
                >
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Close menu</span>
                  <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                </button>

                <div className="ml-0 flex ">
                  <Link to="/">
                    <span className="sr-only">Your Company</span>
                    <img
                      alt=""
                      src="/assets/img/ed/logopng.png"
                      className="h-16 w-auto"
                    />
                  </Link>
                </div>


              </div>
              {/* Links */}
              <TabGroup className="mt-2">
                <div className="border-b border-gray-200">
                  <TabList className="-mb-px flex space-x-8 px-4">
                    {navigation.categories.map((category) => (
                      <Tab
                        key={category.name}
                        className="flex-1 whitespace-nowrap border-b-2 border-transparent px-1 pb-4 text-base font-medium text-gray-900 data-[selected]:border-yellow-600 data-[selected]:text-gray-600"
                      >
                        {category.name}
                      </Tab>
                    ))}
                  </TabList>
                </div>
                <TabPanels as={Fragment}>
                  {navigation.categories.map((category) => (
                    <TabPanel key={category.name} className="space-y-10 px-4 py-4">
                      <div className="grid grid-cols-2 gap-x-4">
                        {category.featured.map((item) => (
                          <div key={item.name} className="group relative text-sm">
                            <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75">
                              <img alt={item.imageAlt} src={item.imageSrc} className="object-cover object-center" />
                            </div>
                            <a href={item.href} className="mt-6 block font-medium text-gray-900">
                              <span aria-hidden="true" className="absolute inset-0 z-10" />
                              {item.name}
                            </a>
                            <p aria-hidden="true" className="mt-1">
                              Shop now
                            </p>
                          </div>
                        ))}
                      </div>
                      {category.sections.map((section) => (
                        <div key={section.name}>
                          <p id={`${category.id}-${section.id}-heading-mobile`} className="font-medium text-gray-900">
                            {section.name}
                          </p>
                          <ul
                            role="list"
                            aria-labelledby={`${category.id}-${section.id}-heading-mobile`}
                            className="mt-6 flex flex-col space-y-2 lg:space-y-6"
                          >
                            {section?.items?.map((item) => (
                              <li key={item?.name} className="flex">
                                <Link to={`/card/detail/${item?._id || item?.id}`} className="hover:text-gray-800 capitalize">
                                  {item?.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </TabPanel>
                  ))}
                </TabPanels>
              </TabGroup>
              <div className="space-y-6 border-t border-gray-200 px-4 py-6">
                {navigation.pages.map((page) => (
                  <div key={page.name} className="flow-root">
                    <a href={page.href} className="-m-2 block p-2 font-medium text-gray-900">
                      {page.name}
                    </a>
                  </div>
                ))}
              </div>
              <div className="space-y-6 border-t border-gray-200 px-4 py-6">
                <div className="flow-root">
                  <a href="#" className="-m-2 block p-2 font-medium text-gray-900">
                    Sign in
                  </a>
                </div>
                <div className="flow-root">
                  <a href="#" className="-m-2 block p-2 font-medium text-gray-900">
                    Create account
                  </a>
                </div>
              </div>
            </DialogPanel>
          </div>
        </Dialog>
        <header className="relative bg-[#FFF4F4]">
          <nav aria-label="Top" className="">
            <div className="border-b-2 border-gray-200">
              <div className="flex h-24 items-center px-2 gap-2 lga:gap-4 lg:px-10">
                <button
                  type="button"
                  onClick={() => setOpen(true)}
                  className="relative rounded-md bg-white p-2 text-gray-400 lg:hidden"
                >
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Open menu</span>
                  <Bars3Icon aria-hidden="true" className="h-6 w-6" />
                </button>
                {/* Logo */}
                <div className="ml-0 flex ">
                  <Link to="/">
                    <span className="sr-only">Your Company</span>
                    <img
                      alt=""
                      src="/assets/img/ed/logopng.png"
                      className="h-10 lg:h-20 w-auto"
                    />
                  </Link>
                </div>
                {/* Flyout menus */}
                <PopoverGroup className="hidden lg:ml-10 lg:block lg:self-stretch">
                  <div className="flex h-full space-x-10">
                    {navigation.categories.map((category) => (
                      <Popover key={category.name} className="flex">
                        <div className="relative flex">
                          <PopoverButton className="relative z-10 -mb-px flex items-center border-b-2 border-transparent pt-px text-sm font-medium text-gray-700 transition-colors duration-200 ease-out hover:text-gray-800 focus:outline-0 data-[open]:border-[#F58D18] data-[open]:text-[#F58D18]">
                            {category.name}
                          </PopoverButton>
                        </div>
                        <PopoverPanel
                          transition
                          className="absolute inset-x-0 z-50 top-full text-sm text-gray-500 transition data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                          <div aria-hidden="true" className="absolute inset-0 top-1/2 bg-white shadow" />
                          <div className="relative bg-white">
                            <div className="mx-auto max-w-7xl px-8">
                              <div className="grid grid-cols-2 gap-x-8 gap-y-10 py-16">
                                <div className="col-start-2 grid grid-cols-2 gap-x-8">
                                  {category?.featured?.map((item) => {
                                    return <div key={item?.name} className="group relative text-base sm:text-sm">
                                      <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75">
                                        <img
                                          alt={item?.name}
                                          src={methodModel.noImg(item?.image)}
                                          className="object-cover object-center"
                                        />
                                      </div>
                                      <Link to={`/card/detail/${item?._id || item?.id}`} className="mt-6 block font-medium text-gray-900 capitalize">
                                        <span aria-hidden="true" className="absolute inset-0 z-10" />
                                        {item?.name}
                                      </Link>
                                      <p aria-hidden="true" className="mt-1">
                                        Shop now
                                      </p>
                                    </div>
                                  }
                                  )}
                                </div>
                                <div className="row-start-1 grid grid-cols-3 gap-x-8 gap-y-10 text-sm">
                                  {category.sections.map((section) => (
                                    <div key={section.name}>
                                      <p id={`${section.name}-heading`} className="font-medium text-gray-900">
                                        {section.name}
                                      </p>
                                      <ul
                                        role="list"
                                        aria-labelledby={`${section.name}-heading`}
                                        className="mt-6 space-y-6 sm:mt-4 sm:space-y-4"
                                      >
                                        {section?.items?.map((item) => (
                                          <li key={item?.name} className="flex">
                                            <Link to={`/card/detail/${item?._id || item?.id}`} className="hover:text-gray-800 capitalize">
                                              {item?.name}
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </PopoverPanel>
                      </Popover>
                    ))}
                    {navigation.pages.map((page) => (
                      <a
                        key={page.name}
                        href={page.href}
                        className="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800"
                      >
                        {page.name}
                      </a>
                    ))}
                  </div>
                </PopoverGroup>
                <div className="ml-auto flex gap-2 lg:gap-4 items-center">
                  {sections?.map((item, index) => {
                    if (item?.show) {
                      return <div className="mr-5" key={index}>
                        <div className="hover:text-[#F58D18] text-sm cursor-pointer" onClick={e => { navigate(item?.path) }}>{item?.title}</div>
                      </div>
                    }
                  })}
                  {token && user?.role?._id !== environment?.recipientRole ?
                    <div className="relative">
                      <MdOutlineShoppingCartCheckout onClick={e => { navigate("/checkout") }} size={30} className='text-primary cursor-pointer' />
                      {checkOutData?.total !== 0 && <span className='bg-primary p-1 h-6 w-6 rounded-full flex items-center justify-center text-xs shadow-sm absolute -top-4 -right-2'>{checkOutData?.total > 9 ? "9+" : checkOutData?.total}</span>}
                    </div>
                    : null
                  }
                  {user?.loggedIn && token ?
                    <Popover className="relative ml-0 flow-root lg:ml-6">
                      <PopoverButton className="focus:outline-0">
                        <div className="flex items-center">
                          <div className="flex items-center">
                            <img alt="image" src={methodModel.userImg(user?.image)} className="h-12 w-12 rounded-full object-cover" />
                          </div>
                        </div>
                      </PopoverButton>
                      <PopoverPanel anchor="bottom" className="flex flex-col w-52 bg-gray-50 p-2 mt-2 shadow">
                        <Link to="/profile" className="group flex w-full items-center text-sm gap-2 rounded-lg hover:bg-[#f78b35] hover:text-white py-1.5 px-3 data-[focus]:bg-white/10">
                          <LuUser className="size-4 fill-white/30" />Profile
                        </Link>
                        <Link to="/changepassword" className="group flex w-full items-center text-sm gap-2 hover:bg-[#f78b35] hover:text-white rounded-lg py-1.5 px-3 data-[focus]:bg-white/10">
                          <IoSettingsOutline className="size-4 fill-white/30" />Change Password
                        </Link>
                        <div className="my-1 h-px bg-black/5" />
                        <button className="group flex w-full items-center text-sm gap-2 rounded-lg py-1.5 px-3 hover:bg-[#f78b35] hover:text-white data-[focus]:bg-white/10" onClick={() => Logout()}>
                          <LuLogOut className="size-4 fill-white/30" />Logout
                        </button>
                      </PopoverPanel>
                    </Popover>
                    :
                    <>
                      <div className="flex  lg:ml-6">
                        <Link to="/login" className="text-sm font-medium text-gray-700 hover:text-gray-800">
                          Log In
                        </Link>
                      </div>
                      <div className="ml-0 flow-root lg:ml-6">
                        <Link to="/register" className="group -m-2 flex items-center p-2">
                          <span className=" lg:text-sm text-xs font-medium bg-primary px-2 lg:px-4 py-2 text-white rounded-lg"> Sign Up For Free</span>
                        </Link>
                      </div>
                    </>
                  }
                </div>
              </div>
            </div>
          </nav>
        </header>
      </div>
    </>
  );
};

export default Html;
